import { render } from "./PageDesignerSectionV3.vue?vue&type=template&id=695bcc64&scoped=true"
import script from "./PageDesignerSectionV3.vue?vue&type=script&lang=js"
export * from "./PageDesignerSectionV3.vue?vue&type=script&lang=js"

import "./PageDesignerSectionV3.vue?vue&type=style&index=0&id=695bcc64&lang=scss&scoped=true"
import "./PageDesignerSectionV3.vue?vue&type=style&index=1&id=695bcc64&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695bcc64"]])

export default __exports__